'use client';
import { useState, useEffect, useRef } from 'react';
import reccomendedAvailability from '@/services/RecommendedAvailability';
import OnePageCheckoutView from './OnePageCheckout.component';
import createAvailabilitySelectionMachine, {
  MentorCheckoutInfo,
} from '@/components/molecules/AvailabilitySelectionModule/AvailabilitySelectionModule.machine';
import onePageCheckoutMachineCreator from './OnePageCheckout.machine';
import styles from './OnePageCheckout.module.css';
import CloseButton from '@/components/atoms/CloseButton';
import { makeCreatePendingSession } from './helpers';
import { useContext } from 'react';
import { OnePageCheckoutContext } from '@/providers/OnePageCheckout.provider';
import { usePostHog } from 'posthog-js/react';
import AvailabilitySelectionSkeleton from '../../molecules/AvailabilitySelectionModule/components/AvailabilitySelectionSkeleton.component';

interface OnePageCheckoutProps {
  thirty_minute_slots: string[];
  sixty_minute_slots: string[];
  mentor_info: MentorCheckoutInfo;
}

const OnePageCheckout = ({
  thirty_minute_slots,
  sixty_minute_slots,
  mentor_info,
}: OnePageCheckoutProps) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // const visability_checkout = elementDisplay("one_page_checkout");

  const { open, toggleOpen } = useContext(OnePageCheckoutContext);
  const posthog = usePostHog();

  const processedThirtyMinuteSlots = reccomendedAvailability(
    thirty_minute_slots,
    timezone
  );
  const processedSixtyMinuteSlots = reccomendedAvailability(
    sixty_minute_slots,
    timezone
  );

  const AvailabilitySelectionMachine =
    createAvailabilitySelectionMachine({
      thirty_minute_slots: processedThirtyMinuteSlots,
      sixty_minute_slots: processedSixtyMinuteSlots,
      mentor_info,
    });

  const OnePageCheckoutMachine = onePageCheckoutMachineCreator({
    mentor_info,
    AvailabilitySelectionMachine,
    createPendingSession: makeCreatePendingSession(posthog),
  });

  return open ? (
    <div className={styles.container}>
      <div
        id="one_page_checkout"
        className={styles.one_page_checkout}
      >
        <div className={styles.close_button_conatiner}>
          <CloseButton onClick={() => toggleOpen && toggleOpen()} />
        </div>
        <OnePageCheckoutView
          OnePageCheckoutMachine={OnePageCheckoutMachine}
        />
      </div>
    </div>
  ) : (
    <AvailabilitySelectionSkeleton numberOfDays={3} />
  );
};

export default OnePageCheckout;
